import React, { useState, useCallback, useEffect } from 'react'
import { connect } from 'react-redux'
import { Translate } from 'react-localize-redux'
import { Grid, TablePagination } from '@material-ui/core'
import { LoadingSpinner, NotFound, TrainingPackageCard } from 'components'
import {
  fetchFavouriteTrainingPackages,
  updateFavoriteTrainingPackage,
} from 'containers/TrainingPackagesContainer/api'
import { useStyles } from 'containers/TrainingPackagesContainer/styles'
import PropTypes from 'prop-types'

const TrainingPackagesCarousel = ({ teamUuid }) => {
  const classes = useStyles()

  const [loading, setLoading] = useState(true)
  const [trainingPackages, setTrainingPackages] = useState([])
  const [meta, setMeta] = useState({})
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(1)

  const loadTrainingPackages = useCallback(() => {
    setLoading(true)
    fetchFavouriteTrainingPackages(teamUuid, {
      page: page + 1,
      per_page: rowsPerPage,
    })
      .then((response) => {
        setTrainingPackages(response.data)
        setMeta(response.meta)
      })
      .catch((err) => {
        console.error('Failed to fetch favourite training packages', err)
        setTrainingPackages([])
        setMeta({})
      })
      .finally(() => {
        setLoading(false)
      })
  }, [teamUuid, page, rowsPerPage])

  useEffect(() => {
    loadTrainingPackages()
  }, [loadTrainingPackages])

  const handleFavoriteToggle = (trainingPackage) => {
    updateFavoriteTrainingPackage(
      trainingPackage.uuid,
      !trainingPackage.favorite
    )
      .then(() => {
        loadTrainingPackages(page, rowsPerPage)
      })
      .catch((error) => {
        console.error('Error toggling favorite status:', error)
      })
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  return (
    <>
      <Grid item xs={12}>
        <TablePagination
          labelRowsPerPage={<Translate id="drills.rows-perpage" />}
          component="div"
          count={meta?.total ?? 0}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          className={classes.pagination}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[12, 24, 36]}
          SelectProps={{
            MenuProps: {
              PaperProps: { elevation: 0 },
            },
          }}
        />
      </Grid>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <Grid container spacing={3}>
          {trainingPackages.length > 0 ? (
            trainingPackages.map((trainingPackage) => (
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                lg={3}
                key={trainingPackage.uuid}
              >
                <TrainingPackageCard
                  trainingPackage={trainingPackage}
                  onFavoriteToggle={() => handleFavoriteToggle(trainingPackage)}
                />
              </Grid>
            ))
          ) : (
            <NotFound />
          )}
        </Grid>
      )}
    </>
  )
}

TrainingPackagesCarousel.propTypes = {
  teamUuid: PropTypes.string.isRequired,
}

export default connect(({ team }) => ({
  teamUuid: team.uuid,
}))(TrainingPackagesCarousel)
